import { AutogenLayoutAgencyLink } from "./autogen/AutogenLayoutAgencyLink";
import {  Textbox, LabelProps,  Checkbox,  DataSourceValidationEvent, ValidationResult, Table } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { StringUtil } from "@mcleod/core";
import { error } from "console";

export class AgencyLink extends AutogenLayoutAgencyLink {

    override onLoad() {
        // Set up table-level validation
        this.tableAgencyLink.onValidate = (table: Table): ValidationResult[] => {
            return this.validateTableRecords();
        };
    }

    private validateTableRecords(): ValidationResult[] {
        return [this.validateDuplicates()];
    }

    private validateDuplicates(): ValidationResult {
        // Collect all rows in the table and make a map by agency_id only
        const agencyIdMap: Map<string, boolean> = new Map();

        console.log("Validating duplicates. Table data length:", this.tableAgencyLink.data.length);

        // Loop through all table entries to build the map
        for (const row of this.tableAgencyLink.data) {
            const agencyId = row.get("agency_id");

            console.log(`Checking row: agency_id=${agencyId}`);

            // Only check if we have agency_id
            if (agencyId) {
                // If an entry in that hash exists, throw the error
                if (agencyIdMap.has(agencyId)) {
                    const errorMessage = `Duplicate Agency ID found: ${agencyId}. Duplicate entries are not allowed.`;

                    console.log("Validation failed:", errorMessage);

                    return {
                        isValid: false,
                        caption: errorMessage,
                        component: this.tableAgencyLink
                    };
                }

                // Add this agency_id to the map
                agencyIdMap.set(agencyId, true);
            }
        }

        console.log("No duplicates found");
        return { isValid: true, component: this.tableAgencyLink };
    }

    /** This is an event handler for the onChange event of checkboxPrimary. */
    checkboxPrimaryOnChange(event) {
        console.log(event);
        const parentActiveRow = this.mainDataSource.parentDataSource.activeRow;
        const checkbox = event.target as Checkbox;
        if (!parentActiveRow || !checkbox.checked) return;

        const primaryAgency = parentActiveRow.get("primary_agency", null);
        const newRow = event.target.boundRow;

        const newPrimaryAgency = newRow.data["agency.id"] || newRow.data["agency_id"];

        if(primaryAgency === null || StringUtil.isEmptyString(primaryAgency)){
            parentActiveRow.set("primary_agency", newPrimaryAgency);
        }else if (primaryAgency && newPrimaryAgency && primaryAgency !== newPrimaryAgency) {
           const labelProps: Partial<LabelProps> = {
            text: "The current profile already has a primary agency [" + primaryAgency + "]. Do you wish the change the primary agency to " + newPrimaryAgency + " ?"
        };

        CommonDialogs.showYesNo(labelProps, "Do you want to change the primary agency?").then((result) => {
            if (result) {
                const parentActiveRow = this.mainDataSource.parentDataSource.activeRow;
                if (parentActiveRow) {
                    parentActiveRow.set("primary_agency", newPrimaryAgency);
                    this.tableAgencyLink.data.push(newRow);
                    this.mainDataSource.parentDataSource.post().then( () => {
                        // Clear the values from the uncommitted row (likely the quick add row)
                        const blankRow = this.tableAgencyLink.quickAddRow;
                        if (blankRow) {
                            const checkIsPrimary = blankRow.findComponentById("checkboxPrimary") as Checkbox;
                            const txtAgencyId = blankRow.findComponentById("textboxAgencyId") as Textbox;
                            const txtDescription = blankRow.findComponentById("textboxDescr") as Textbox;
                            if (checkIsPrimary) checkIsPrimary.checked = false;
                            if (txtAgencyId) txtAgencyId.text = "";
                            if (txtDescription) txtDescription.text = "";

                            // Clear the data values
                            blankRow.data.set("is_primary", "N");
                            blankRow.data.set("agency.id", null);
                            blankRow.data.set("agency_id", null);
                            blankRow.data.set("description", null);
                            blankRow.data.set("id", null);
                        }
                    }
                );
                }

            } else {
                newRow.data["is_primary"] = "N";
                checkbox.checked = false;
            }
        });
        }
    }
}

